export default __webpack_public_path__ + "static/media/icons.ebefb063.svg";